import { Easing } from 'react-native';

/** https://gist.github.com/jondot/1317ee27bab54c482e87 */
export const IOS_KEYBOARD_EASE = Easing.bezier(0.17, 0.59, 0.4, 0.77);
